import axios from 'axios';

let base_url = 'https://api.controllersolar.com.br';
if (process.env.NODE_ENV == 'development'){
    base_url = 'http://localhost:9090';
}

const client = axios.create({
  baseURL: base_url,
  timeout: 15000,
  withCredentials: false,
});

export default client;
